module.exports = __webpack_public_path__ + "img/icon_avatar_default.35daa6a5.png";